// Legacy functions from the previous router
// These are only used by header breadcrumb and sidebar
// to check which location/draft you are...

/**
 * @deprecated Use svelte-routing params or stores instead.
 */
function get_project_ref (url_path = window.location.pathname) {
	const parts = url_path.split("/").filter(Boolean);
	return parts[1] || "";
}

/**
 * @deprecated Use svelte-routing params or stores instead.
 */
function get_draft_ref (url_path = window.location.pathname) {
	const parts = url_path.split("/").filter(Boolean);
	return parts[2] || "";
}

/**
 * @deprecated Use svelte-routing params or stores instead.
 */
function get_current_screen (url_path = window.location.pathname) {
	const parts = url_path.split("/").filter(Boolean);
	return parts[0] || "";
}

export { get_current_screen, get_draft_ref, get_project_ref};
